var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryPromoFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 863"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 6",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#009EF7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 19C10.8389 19 9.39131 18.4492 8.15728 17.3476C6.92324 16.2459 6.21619 14.8708 6.03611 13.2222H7.51667C7.68518 14.4741 8.24202 15.5093 9.18717 16.3278C10.1323 17.1463 11.2366 17.5556 12.5 17.5556C13.9083 17.5556 15.1031 17.0649 16.0844 16.0837C17.0656 15.1024 17.556 13.9079 17.5556 12.5C17.5556 11.0917 17.0649 9.89687 16.0837 8.91561C15.1024 7.93435 13.9079 7.44396 12.5 7.44444C11.6694 7.44444 10.8931 7.63704 10.1708 8.02222C9.44861 8.40741 8.84074 8.93704 8.34722 9.61111H10.3333V11.0556H6V6.72222H7.44444V8.41944C8.05833 7.64907 8.80776 7.05324 9.69272 6.63194C10.5777 6.21065 11.5134 6 12.5 6C13.4028 6 14.2485 6.17165 15.0372 6.51494C15.8258 6.85824 16.5119 7.32143 17.0955 7.9045C17.6791 8.48854 18.1425 9.17465 18.4858 9.96283C18.8291 10.751 19.0005 11.5967 19 12.5C19 13.4028 18.8284 14.2485 18.4851 15.0372C18.1418 15.8258 17.6786 16.5119 17.0955 17.0955C16.5115 17.6791 15.8254 18.1425 15.0372 18.4858C14.249 18.8291 13.4033 19.0005 12.5 19ZM14.5222 15.5333L11.7778 12.7889V8.88889H13.2222V12.2111L15.5333 14.5222L14.5222 15.5333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryPromoFilledIcon);
export default __webpack_public_path__ + "static/media/history-promo-filled-icon.1926da96355098a8472a89f77f578219.svg";
export { ForwardRef as ReactComponent };